import { useState } from 'react';
import styled from 'styled-components';

import BookingCTA from 'components/BookingCTA';

import BREAKPOINTS from 'styles/breakpoints';
import COLORS from 'styles/colors';
import { Grid, columns } from 'styles/grid';
import { groupBy, formatEnumToString } from 'utils/helpers';

import AccordionItem from './AccordionItem';
import Dropdown from './Navigation/Dropdown';
import HeroSection from './HeroSection';
import SideNav from './Navigation/SideNav';

const Section = styled.section`
  position: relative;
  background-color: ${COLORS.pinkMuted};
`;

const BgRoundel = styled.img`
  display: none;
  position: absolute;
  bottom: 24%;
  left: -470px;

  ${BREAKPOINTS.medium`
    display: block;
  `}
`;

const Container = styled(Grid)`
  padding-bottom: 64px;

  ${BREAKPOINTS.medium`
    padding: 80px var(--gutter-side) 120px;
    min-height: 500px;
  `}
`;

const MobileNav = styled(Dropdown)`
  ${columns(null, 12)}
  width: 100%;
  transform: translateY(-25px);

  ${BREAKPOINTS.medium`
    display: none;
  `}
`;

const DesktopNav = styled(SideNav)`
  display: none;

  ${BREAKPOINTS.medium`
    ${columns(2, 3)}
    display: block;
    padding-top: 40px;
  `}
`;

const Items = styled.ul`
  ${columns(null, 12)}
  transform: translateY(-20px);

  ${BREAKPOINTS.medium`
    ${columns(6, 7)}
    max-width: 800px;
  `}

  ${BREAKPOINTS.large`
    ${columns(5, 8)}
  `}
`;

const FaqsPage = ({ page: { title, subtitle, faqItems } }) => {
  const faqsByCategory = groupBy(faqItems, 'category');

  const categories = Object.keys(faqsByCategory).map((category) => {
    return {
      label: formatEnumToString(category),
      value: category,
    };
  });

  const [activeCategory, setActiveCategory] = useState(categories[0]?.value);

  return (
    <Section>
      <BgRoundel src="/images/backgrounds/bg-roundel-dark.svg" alt="" />
      <HeroSection title={title} subtitle={subtitle} />

      <Container>
        <MobileNav
          items={categories}
          activeItem={activeCategory}
          onClick={(value) => setActiveCategory(value)}
        />
        <DesktopNav
          items={categories}
          activeItem={activeCategory}
          setActiveItem={setActiveCategory}
        />
        <Items>
          {faqsByCategory[activeCategory]?.map(({ label, content }) => (
            <AccordionItem
              key={label}
              label={label}
              content={content}
              color="forest"
            />
          ))}
        </Items>
      </Container>

      <BookingCTA bgColor="transparent" />
    </Section>
  );
};

export default FaqsPage;
